import { errorAction, successfulAction } from '@shared/actions';
import { addFavorites, deleteFavorites } from '@services/user.service';
import { TOGGLE_FAVORITES } from '@core/reducers/shop/actionTypes';
import trackFavoritesClicked from '@core/reducers/shop/tracking/trackFavoritesClicked';

const type = TOGGLE_FAVORITES;

const toggleFavorite = (restaurantId, isAddingToFavorites) => async (
  dispatch,
  _,
  axios,
) => {
  const errorMessage = isAddingToFavorites
    ? 'Ocurrió un error al agregar el favorito.'
    : 'Ocurrió un error al eliminar el favorito.';
  const payload = { shopId: restaurantId };

  try {
    dispatch({ type, payload });

    const { success, error } = isAddingToFavorites
      ? await addFavorites({ axios, restaurantId })
      : await deleteFavorites({ axios, restaurantId });

    if (success) {
      dispatch(successfulAction({ type, payload }));
      trackFavoritesClicked({
        shopId: restaurantId,
        isAddingToFavorites,
      });
      return true;
    }

    dispatch(errorAction({ type, payload, error, errorMessage }));
    return false;
  } catch (error) {
    dispatch(errorAction({ type, payload, error, errorMessage }));
    return false;
  }
};

export default toggleFavorite;
